import type { BrandType } from '@mathflat/domain/@entities/Brand/type'

import { hcmsLandingPathController } from '@/controller/landingPath.controller'
import type { Academy } from '@/dto'
import commonRepo from '@/repository/common.repo'
import { getEntrancePage, RouteName } from '@/router'

type FallbackConfig = {
  shouldFetchFromAPI: boolean
  brand?: BrandType
  fallbackUrl: string
}

const getBrandConfig = (): FallbackConfig => {
  const commonEntrancePath = getEntrancePage()

  if (commonRepo.isSeoltab) {
    return {
      shouldFetchFromAPI: false,
      fallbackUrl: commonEntrancePath,
    }
  }

  return {
    shouldFetchFromAPI: true,
    brand: 'MATHFLAT',
    fallbackUrl: RouteName.myWorksheet,
  }
}

const fetchLandingPathFromAPI = async (
  brand: BrandType,
  dCode: Academy['academyId'],
): Promise<string | null> => {
  try {
    return await hcmsLandingPathController.getHomeButtonLandingPath(brand, dCode)
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getHomeButtonLandingPath = async (): Promise<string> => {
  const config = getBrandConfig()

  if (!config.shouldFetchFromAPI || !config.brand) {
    return config.fallbackUrl
  }

  const apiLandingPath = await fetchLandingPathFromAPI(config.brand, commonRepo.academy?.academyId)
  return apiLandingPath ?? config.fallbackUrl
}
